<div class="content-row">
  <ng-content></ng-content>
</div>
